<h3 class="ui primary header" >{{ modal.context.title }}
	<i class="link times icon" (click)="modal.deny(undefined)"></i>
	</h3>
 <div class="content" >
       <div class="scroll-wrapper ui basic segment" [ngClass]="{'loading':pending}">
      <div *ngIf="success || error" tamsyMargin marginY="10px">
            <esl-message-toast [(message)]="error"></esl-message-toast>
            <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
            </div>
         <!--Laboratory form  -->
         <div fxLayout="row" fxLayoutAlign="space-between center" appMargin marginB="8"> 
            <h3 fxFlex="grow" class="ui primary header">Year Record</h3>
            <div fxFlex ><button (click)="yearRecord()" class="ui tiny button"><i class="plus icon"></i></button></div>
      </div>
      <div class="ui divider"></div>


           
        <div  class="ui  segment section" fxLayout="row" fxLayoutAlign="space-between center">
            <div fxFlex="grow">
                  2019 Year Records
            
                  
            </div>
            <div fxFlex fxLayout="row">
                  <button class="ui tiny button"><i class="trash alternate outline icon"></i></button>
                  <button (click)="editRecord()" class="ui tiny button"><i class="pen icon"></i></button>
            </div>
          
        </div>
        <div class="ui  segment section" fxLayout="row" fxLayoutAlign="space-between center">
            <div fxFlex="grow">
                  2020 Year Record
            </div>
            <div fxFlex fxLayout="row">
                  <button class="ui tiny button"><i class="trash alternate outline icon"></i></button>
                  <button class="ui tiny button"><i class="pen icon"></i></button>
            </div>
        </div>
 </div>
 </div>

      <div  class="actions">
    <button class="ui  basic primary button" (click)="modal.deny(undefined)">Cancel</button>
            <button class="ui  primary button" [ngClass]="{'yellow':pending}" [disabled]="pending" (click)="save()" autofocus>Done</button>

      </div>


